var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CTableWrapper',{attrs:{"items":_vm.parentCategories,"is-loading":_vm.isLoading,"small":"","fixed":"","border":"","sorter":"","sorter-value":{ column: 'name', asc: true },"column-filter":"","fields":_vm.fields,"icon":"cil-tags","type":"ParentCategory","caption":"ParentCategories"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }